import 'css-chunksrc/client/pages/utilityPage/projectPage/projectStatusesList/status/styles.scss';export default {
  "status": "_status_4fehb_1",
  "personalized": "_personalized_4fehb_14",
  "wrapper": "_wrapper_4fehb_22",
  "color": "_color_4fehb_31",
  "name": "_name_4fehb_37",
  "custom": "_custom_4fehb_47",
  "description": "_description_4fehb_51",
  "iconBox": "_iconBox_4fehb_57",
  "icon": "_icon_4fehb_57",
  "colorPickerInput": "_colorPickerInput_4fehb_74",
  "colorPicker": "_colorPicker_4fehb_74"
};